



























import Vue from 'vue';
import { SEARCH_URL } from '@/constants';
import { searchFieldByName } from '@/searchFields';
import { compareLemmas, handleAjaxError, ErrorDisplay, ErrorType } from '@/util/util';
import ErrorAlert from '@/generic/components/ErrorAlert.vue';

interface Result {
  pid: string,
  title: string,
  'part-of-speech': string,
  examples: string[],
  url: string,
}

export default Vue.extend({

  components: {
    ErrorAlert,
  },

  data() {
    return {
      results: [] as Result[],
      error: null as ErrorDisplay|null,
      loading: false,
    };
  },

  computed: {
    searchString() { return this.$route.query.q || this.$route.params.title; },
    findIn() { return this.$route.query.in ? (this.$route.query.in as string) : 'lemma'; }
  },

  mounted() {
    this.performSearch();
  },

  watch: {
    $route() {
      this.performSearch();
    },
  },

  methods: {

    inDisplay(inField: string): string {
      return (searchFieldByName(inField) || { display: 'UNKNOWN' }).display;
    },

    async performSearch() {
      let response = undefined;
      try {
        const search = this.searchString;
        const findIn = this.findIn;
        const field = (searchFieldByName(findIn) || { field: 'lemma' }).field;
        let params;
        if (field === 'lemma-tokenized') {
          params = {
            [`q.${field}`]: search,
            [`q.${field.replace(/^lemma/, "variant")}`]: search, // also search variant
            rows: 10000, 
            sort: 'lemma asc',
          };
        } else {
          params = {
            [`q.${field}`]: search,
            rows: 10000, 
            sort: 'lemma asc',
          };
        }
        this.loading = true;
        response = await Vue.axios.get(SEARCH_URL, { params });
        if (response.data.results.length === 1) {
          const res = response.data.results[0];
          const trimmed = search ? (search as string).trim() : '';
          if (res.title === trimmed || `"${res.title}"` === trimmed) {
            // Single exact match. Immediately go to the article page.
            this.$router.push({ path: `/docs/${encodeURIComponent(res.title)}/${encodeURIComponent(res.pid)}` });
            return;
          }
        }
        this.results = response.data.results;
        this.results.sort(compareLemmas);
        this.error = null;
      } catch (err) {
        this.error = handleAjaxError(err as ErrorType);
      } finally {
        this.loading = false;
      }
    }
  }
});
